import React, { useEffect, useState } from "react";
import axios from "axios";

const Report = () => {
    const [loading, setLoading] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [error, setError] = useState(null);

    const fetchLeads = async () => {
        setLoading(true);
        setError(null);

        // Get today's date in YYYY-MM-DD format
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const todayStr = `${yyyy}-${mm}-${dd}`;

        const data = JSON.stringify({
            Parameter: [
                {
                    LookupName: "CreatedOn",
                    LookupValue: "2025-06-27", // You can replace this with `todayStr` if you want it to always use the current date
                    SqlOperator: "="
                },
                {
                    LookupName: "Source",
                    LookupValue: "Chat,Website",
                    SqlOperator: "IN"
                }
            ],
            Columns: {
                Include_CSV:
                    'ProspectID,FirstName,LastName,EmailAddress,Phone,Source,mx_Programme,Stage,SourceCampaign,CreatedOn',
            },
            Paging: {
                PageIndex: 1,
                PageSize: 1000,
            },
            Sorting: {
                ColumnName: 'CreatedOn',
                Direction: '1',
            },
        });

        const config = {
            method: "post",
            url: "https://api-in21.leadsquared.com/v2/LeadManagement.svc/Leads.Get?accessKey=u$r1d64e7e490a71e5105cf6a1a3efcd1fe&secretKey=48390d57d17254e36ee25ca1b12517e5b28e1355",
            headers: {
                "Content-Type": "application/json",
            },
            data,
        };

        try {
            const response = await axios.request(config);
            const leads = response.data || [];
            setRecordCount(leads.length);
        } catch (err) {
            console.error("Error fetching leads:", err);
            setError("Failed to fetch leads.");
            setRecordCount(0);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchLeads();
    }, []);

    return (
        <div className="p-6 max-w-3xl mx-auto bg-gray-50 min-h-screen">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
                📋 Today's Leads Report
            </h2>

            {loading ? (
                <div className="flex items-center space-x-2 text-blue-500 font-semibold">
                    <svg
                        className="animate-spin h-5 w-5 text-blue-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                        ></path>
                    </svg>
                    <span>Fetching data...</span>
                </div>
            ) : error ? (
                <div className="text-red-600 font-semibold">{error}</div>
            ) : (
                <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">
                        Total Leads Created Today
                    </h3>
                    <p className="text-4xl font-bold text-blue-600">{recordCount}</p>
                </div>
            )}
        </div>
    );
};

export default Report;
